module.exports = __webpack_public_path__ + "static/media/5.cc5aa5e9.jpg";